module.exports = __webpack_public_path__ + "resource/img/person.ac87e322.svg";